var _path, _path2, _path3, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlagForTanzaniaSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-hidden": "true",
    role: "img",
    className: "iconify iconify--emojione",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 6C6.3 12.2.9 23.9 2.2 35.3L49.8 7.9C40.5 1 27.7-.1 17 6z",
    fill: "#83bf4f"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2 56.1c9.3 6.9 22.2 8 32.8 1.8c10.7-6.1 16.1-17.8 14.8-29.3L14.2 56.1",
    fill: "#428bc1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M58 17c-1.4-2.4-3.1-4.5-5-6.4L3 39.5c.7 2.6 1.7 5.1 3 7.5c1.4 2.4 3.1 4.5 5 6.4l50-28.9c-.6-2.6-1.6-5.1-3-7.5",
    fill: "#3e4347"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#ffce31"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.5 26.5c-.1-.7-.3-1.4-.5-2L11 53.4c.5.5 1 1 1.5 1.4c.5.5 1.1.9 1.7 1.3l47.6-27.5l-.3-2.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5 9.2c-.5-.5-1.1-.9-1.7-1.3L2.2 35.3l.3 2.1c.1.7.3 1.4.5 2l50-28.8c-.5-.5-1-1-1.5-1.4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagForTanzaniaSvgrepoCom);
export default __webpack_public_path__ + "static/media/flag-for-tanzania-svgrepo-com.28b831278b93ea26dac8297a5cd09ef3.svg";
export { ForwardRef as ReactComponent };